<div *ngIf="data.overview" class="dialog-content">
  <h1 mat-dialog-title>
    {{ 'transportOrder.dates.dialog.title.' + (data.actionType | lowercase) | translate }}
  </h1>

  <div
    *ngIf="
      data.actionType === transportationTrackingActionType.Pickup
        ? data.overview.pickup
        : data.overview.delivery as actionDetails
    "
    mat-dialog-content
  >
    <h3 class="subtitle">
      {{ 'common.field.address' | translate }}
    </h3>
    <div class="tw-flex tw-gap-x-8">
      <div class="tw-basis-1/2">
        <ui-info-field-item [label]="'common.field.id' | translate" [text]="actionDetails.id"></ui-info-field-item>
        <ui-info-field-item
          [label]="'common.list.th.name' | translate"
          [text]="actionDetails.name"
        ></ui-info-field-item>
      </div>
      <div class="tw-basis-1/2">
        <ui-info-field-item
          [label]="'common.list.th.type' | translate"
          [text]="actionDetails.type"
        ></ui-info-field-item>
        <ui-info-field-item
          [label]="'common.field.address' | translate"
          [text]="actionDetails.address"
        ></ui-info-field-item>
      </div>
    </div>
  </div>

  <h3 class="subtitle">
    {{ 'transportOrder.dates.dialog.subtitle.dates' | translate }}
  </h3>

  <div *ngIf="data.overview.dates as dates">
    <div class="field">
      <div class="field__label">
        {{ 'transportOrder.dates.type.planned' | translate }}
      </div>
      <ui-dates-with-divider
        *ngIf="data?.overview?.transportOrderNumber; else singlePlannedTimeTemplate"
        [startDate]="dates[dateFieldsConfig[transportationTrackingDateType.Planned][0]]"
        [endDate]="dates[dateFieldsConfig[transportationTrackingDateType.Planned][1]]"
      ></ui-dates-with-divider>
    </div>

    <ui-info-field-item [label]="'transportOrder.dates.type.estimated' | translate">
      <ui-date-with-timezone
        [localDate]="dates[dateFieldsConfig[transportationTrackingDateType.Estimated][0]]"
      ></ui-date-with-timezone>
    </ui-info-field-item>

    <ui-info-field-item [label]="'transportOrder.dates.type.actual' | translate">
      <ui-date-with-timezone
        [localDate]="dates[dateFieldsConfig[transportationTrackingDateType.Actual][0]]"
      ></ui-date-with-timezone>
    </ui-info-field-item>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
  </div>
</div>

<ng-template #singlePlannedTimeTemplate>
  <ui-date-with-timezone
    *ngIf="data?.overview?.dates as dates"
    [localDate]="
      data?.actionType === transportationTrackingActionType.Pickup ? dates?.plannedDeparture : dates?.plannedArrival
    "
  ></ui-date-with-timezone>
</ng-template>
